module.exports = __webpack_public_path__ + "static/media/cv.accdfa0e.svg";